import http from '@/utils/http';

export const getTridToken = (data: any) => {
  return http({
    url: '/talent/ticket/ticketValidate',
    method: 'POST',
    data: data
  });
};
//token验证
export const getTokenValidate = () => {
  return http({
    url: '/talent/ticket/tokenValidate',
    method: 'GET'
  });
};
export const getUserInfo = (data: any) => {
  return http({
    url: '/talent/tr/info',
    method: 'get',
    params: data
  });
};
//接单开关
export const putSwitchStatus = (data: any) => {
  return http({
    url: '/talent/tr/switchStatus',
    method: 'post',
    params: data
  });
};
//心情状态
export const putDefine = (data: any) => {
  return http({
    url: '/talent/tr/setDefine',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data
  });
};
//小翼君-dot收益
export const getDotTrPredictIncome = (data: any) => {
  return http({
    url: '/dottask/trPredictIncome',
    method: 'post',
    data: data
  });
};

//消息数量
export const getMsgCount = (trid: string) => {
  return http({
    url: '/talent/tr/msgCount?trId=' + trid,
    method: 'get'
  });
};
//团队版/个人版
export const getLevelPrivilege = () => {
  return http({
    url: '/talent/tr/levelPrivilege',
    method: 'get'
  });
};

//版本更新弹窗
export const getIsShowUpdateModal = () => {
  return http({
    url: '/middle/tr/task/tips',
    urlType: 'saas',
    method: 'get'
  });
};

//版本更新弹窗关闭
export const hiddenUpdateModal = () => {
  return http({
    url: '/middle/tr/task/tips',
    urlType: 'saas',
    method: 'post'
  });
};
